import { fs, messaging } from "../firebase.ts";
import { User } from "firebase/auth";
import {
    doc,
    getDoc,
    where,
    collection,
    query,
    onSnapshot,
    DocumentData,
    DocumentSnapshot,
    setDoc,
    arrayUnion,
    Timestamp
} from "firebase/firestore";
import { getToken } from "firebase/messaging";

import { signal, computed } from "@preact/signals";
import { HbMain } from "../components/hb-main/hb-main.ts";

interface Profile {
    rank: number;
    uid: string;

    displayName: string;
    photoURL: string;
    username: string;

    heartkey: string;
    trustkey: string;

    kiitos: number;
    kiitti: number;

    fund: number;
    account: number;

    isBroadcast: boolean;

    // kiitos aura
    //kiitosDate: Timestamp;
    kiitosFrequency: number;
    kiitosAmplitude: number;

    // kiitti aura
    //kiittiDate: Timestamp;
    kiittiFrequency: number;
    kiittiAmplitude: number;

    // TODO: later store lastUpdated
    address: string;
    latitude: number;
    longitude: number;
}

const swURL = new URL("../sw.js", import.meta.url);

//TODO: can store other collections in localStorage too! collections that are used across all views!
export class Hero {
    private user: User;
    private unsubscribe: () => void;
    private unsubscribe2: () => void;

    private signal = signal<string>(localStorage.getItem("hero") || "{}");
    private main = document.querySelector("hb-main") as HbMain;

    async initUser() {
        const userDocRef = doc(fs, "users", this.user.uid);
        const userDoc = await getDoc(userDocRef);
        localStorage.setItem(
            "hero",
            JSON.stringify({
                id: userDoc.id,
                ...userDoc.data()
            })
        );
    }

    constructor(user: User) {
        this.user = user;
        const userDocRef = doc(fs, "users", user.uid);
        this.unsubscribe = onSnapshot(
            userDocRef,
            (snapshot: DocumentSnapshot<DocumentData>) => {
                if (snapshot.exists()) {
                    localStorage.setItem(
                        "hero",
                        JSON.stringify({
                            id: snapshot.id,
                            ...snapshot.data()
                        })
                    );
                    // TODO: re-render all components
                    this.signal.value = localStorage.getItem("hero")!;
                    this.main.renderShip(this.user);
                    this.main.renderSilver(this.user);
                    this.main.renderX(this.user);
                }
            },
            (error) => {
                console.error("Snapshot Hero Error:", error);
            }
        );

        // profiles
        const usersQuery = query(
            collection(fs, "users"),
            where("username", "!=", null)
        );
        this.unsubscribe2 = onSnapshot(
            usersQuery,
            (querySnapshot) => {
                const profiles: Profile[] = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    //if (data.heartkey || data.trustkey)
                    profiles.push({
                        uid: doc.id,

                        displayName: data.displayName || "",
                        photoURL: data.photoURL || "",
                        username: data.username,

                        heartkey: data.heartkey || "",
                        trustkey: data.trustkey || "",

                        kiitos: data.kiitos || 0,
                        kiitti: data.kiitti || 0,

                        fund: data.fund || 0, // aquarian fund
                        account: data.account || 0, // account balance

                        isBroadcast: data.isBroadcast || false,

                        //kiitosDate: data.kiitosDate,
                        kiitosFrequency: data.kiitosFrequency || 0,
                        kiitosAmplitude: data.kiitosAmplitude || 0,

                        //kiittiDate: data.kiittiDate,
                        kiittiFrequency: data.kiittiFrequency || 0,
                        kiittiAmplitude: data.kiittiAmplitude || 0,

                        address: data.address || "",
                        latitude: data.latitude || 0,
                        longitude: data.longitude || 0
                    } as Profile);
                });

                // sort by rank
                // 1. Sort by average frequency (descending)
                profiles.sort((a, b) => {
                    const avgA = (a.kiitosFrequency + a.kiittiFrequency) / 2;
                    const avgB = (b.kiitosFrequency + b.kiittiFrequency) / 2;
                    return avgB - avgA;
                });
                // 2. Add rank
                const rankedProfiles = profiles.map((profile, index) => ({
                    ...profile,
                    rank: index + 1
                }));

                // sort by name
                rankedProfiles.sort((a, b) => {
                    const hasA = !!a.displayName;
                    const hasB = !!b.displayName;

                    // 1. Items with displayName come first
                    if (hasA && !hasB) return -1;
                    if (!hasA && hasB) return 1;

                    // 2. Both have displayName → sort by displayName
                    if (hasA && hasB) {
                        return a.displayName.localeCompare(
                            b.displayName,
                            undefined,
                            {
                                sensitivity: "base"
                            }
                        );
                    }

                    // 3. Neither has displayName → sort by username
                    return a.username.localeCompare(b.username, undefined, {
                        sensitivity: "base"
                    });
                });

                localStorage.setItem("heroes", JSON.stringify(rankedProfiles));
            },
            (error) => {
                console.error("Snapshot Heroes Error:", error);
            }
        );
    }

    public logout() {
        this.unsubscribe();
        this.unsubscribe2();
        localStorage.removeItem("hero");
    }

    // needed bc tokens are refreshed and deleted
    public async saveTokenToFirestore() {
        try {
            // const permission = await Notification.requestPermission();
            // if (permission !== "granted") {
            //     alert(
            //         "Please add this app to your Home Screen and allow Push Notifications to receive an alert whenever someone nearby thanks you!"
            //     );
            //     return;
            // }

            const registration = await navigator.serviceWorker.register(swURL);

            const currentToken = await getToken(messaging, {
                vapidKey:
                    "BNuEXHVA_ROIoh-e_sErqz-EDL2k4K1Yxhp7ge6UeH2HFqlhKyXx7M2BJZX3H5Y7QGK7E7NuuxsWmweYJPEVdGw",
                serviceWorkerRegistration: registration
            });

            if (currentToken) {
                const userRef = doc(fs, "users", this.user.uid);

                // Add token to an array so we don't overwrite other devices
                await setDoc(
                    userRef,
                    {
                        fcmTokens: arrayUnion(currentToken)
                        //lastUpdated: new Date() // auto converted to Firestore Timestamp // pro not needed
                    },
                    { merge: true }
                );

                console.log("Token saved to Firestore successfully");
            }
        } catch (error) {
            console.error("Error saving token:", error);
        }
    }
}
